/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react';
import { Container } from '@adobe/aem-react-editable-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import clsx from 'clsx';

export const DynamicWrapperContext = createContext({ isInsideDynamicWrapper: false });

export const useDynamicWrapperContext = () => useContext(DynamicWrapperContext);

export const DynamicWrapperConfig = {
  emptyLabel: 'dynamicWrapper',
  isEmpty: false,
  resourceType: `mi-aem-common-spa/components/common/dynamicwrapper`,
};

export const DynamicWrapperEditable = (props: any) => {
  return (
    <DynamicWrapperContext.Provider value={{ isInsideDynamicWrapper: true }}>
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
      />
    </DynamicWrapperContext.Provider>
  );
};

export const DynamicWrapper = (props: any) => {
  return props?.model?.styleclass ? (
    <div
      data-component-name="o-common-static-dynamicwrapper"
      className={clsx(
        props?.model?.styleclass,
        props?.model?.styleclass.includes('fullbleed') ? 'm-container-fullbleed' : ''
      )}
    >
      <DynamicWrapperEditable {...props} />
    </div>
  ) : (
    <div data-component-name="o-common-static-dynamicwrapper">
      <DynamicWrapperEditable {...props} />
    </div>
  );
};
